module.exports = __webpack_public_path__ + "static/img_9751-a94aca8b7578a08877782ec3e2c80b78.webp";